import { jsx } from "react/jsx-runtime";
import EventBusyIcon from "@mui/icons-material/EventBusy";
import { validateTidalLicense } from "../../base/index.js";
function EventBusy(props) {
  return /* @__PURE__ */ jsx(
    EventBusyIcon,
    {
      "data-testid": "EventBusy",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "EventBusy",
      "data-tidal-icon-meta": "mail,contact,calendar"
    }
  );
}
EventBusy.tidalIconMeta = {
  categories: "mail,contact,calendar",
  name: "EventBusy"
};
validateTidalLicense();
export {
  EventBusy
};
//# sourceMappingURL=EventBusy.js.map
